import { Box, Stack, Typography } from "@mui/material";
import { FormRegisters } from "./components/formRegister/FormRegister";
import logo from "../../assets/img/Logo_Ebom_14.png";

export function HomePage() {
  return (
    <Box width={["100%", "100%", "70%", "70%"]} py={2}>
      <Stack
        direction={["column", "column", "row"]}
        width="100%"
        gap={2}
        alignItems={{ xs: "stretch", md: "center" }}
      >
        <Stack
          flex="1"
          p={2}
          gap={2.5}
          sx={{ color: "white", fontSize: { xs: "1.05rem", md: "1.2rem" } }}
        >
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              height: { xs: 160, md: 200 },
              width: "auto",
              maxWidth: "100%",
              alignSelf: "flex-start",
              filter:
                "drop-shadow(0 4px 12px rgba(0,0,0,0.65)) drop-shadow(0 0 18px rgba(255,220,150,0.25))",
            }}
          />
          <Typography
            fontWeight="bold"
            sx={{ fontSize: { xs: "1.25rem", md: "1.45rem" } }}
          >
            Paz do Senhor Jesus a todos irmãos!
          </Typography>
          <Typography sx={{ fontSize: "inherit", lineHeight: 1.7 }}>
            É com imensa alegria que chegamos a 14ª edição da nossa EBOM (escola bíblica de obreiros e membros),
            uma experiência singular, que nos garantirá uma imersão profunda de aprendizado e envolvimento
            com palavra do Senhor durante quatro dias! Este trabalho que já ultrapassou a primeira década e a cada edição
            se consolida por seu relevante legando no que tange a exposição e ensino do genuíno evangelho.
          </Typography>
          <Typography sx={{ fontSize: "inherit", lineHeight: 1.7 }}>
            Sendo assim para nós do comitê organizador é uma imensa satisfação tê-lo(a) conosco
            em mais esta edição, e esperamos que seja uma experiencia inesquecível
            de crescimento e comunhão com o Senhor e a Sua Palavra. Deus o Abençoe!
          </Typography>
          <Typography sx={{ fontSize: "inherit" }}>
            Atenciosamente,
          </Typography>
          <Typography sx={{ fontSize: "inherit" }}>
            Pr. Setorial Maurício Costa - Itapevi/SP.
          </Typography>
        </Stack>
        <FormRegisters />
      </Stack>
    </Box>
  );
}
